const diferencaAnosDatas = (data1, data2) => {
  const data1Utc = Date.UTC(
    data1.getFullYear(),
    data1.getMonth(),
    data1.getDate()
  );
  const data2Utc = Date.UTC(
    data2.getFullYear(),
    data2.getMonth(),
    data2.getDate()
  );
  const dias = 1000 * 60 * 60 * 24;
  const totalDias = (data2Utc - data1Utc) / dias;
  const totalAnos = totalDias / 365;
  return parseInt(totalAnos, 10);
};

const limitePercentualSaque = () => {
  const opcoes = [];

  const dataDecreto = new Date(2020, 5, 1);
  const dataAtual = new Date();
  const diferencaAnos = diferencaAnosDatas(dataDecreto, dataAtual);
  const porcentagemLimite = 50 - diferencaAnos * 5;
  const limiteMaximo = () => {
    if (porcentagemLimite < 30) return 30;
    return porcentagemLimite;
  };

  for (let i = 0; i <= limiteMaximo(); i += 5) {
    const item = { value: i, label: `${i}%` };
    opcoes.push(item);
  }

  return opcoes;
};

export const opcoesPercentualSaque = limitePercentualSaque();
